import { gql } from 'src/__generated__'

export default gql(`
  mutation removePhoto($id: Int!) {
    removePhoto(id: $id)
  }
`)
